// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U8Dq","right":"styles_right__3qS_q"};